import React from "react";
import HeroSection from "../HeroSection";
import Footer from "../Footer";

function Home() {
  return (
    <>
      <HeroSection />
      {/*<Footer />*/}
    </>
  );
}

export default Home;
